module.exports = __webpack_public_path__ + "img/lg_ring_y_skip_0_1@2x.b0ff3a6a.png";